import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, Optional } from '@angular/core';
import { AppConfig, appConfigService } from '@app/config';
import { DynamicFormService } from '@ntap/common';
import {
  DataSource,
  HttpMethod,
  HttpService,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ServerItemAction,
  ViewWindow
} from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { map, pipe, take, tap } from 'rxjs';

@Component({
  selector: 'app-export-jedinice-gradiva-excel-action',
  templateUrl: './export-jedinice-gradiva-excel-action.component.html'
})
export class ExportJediniceGradivaExcelActionComponent extends ServerItemAction {
  protected pathReportPreviewPdf: string;

  addPodjedinice = false;

  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override window: ViewWindow,
    @Inject(appConfigService) private config: AppConfig,
    private httpService: HttpService
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
    this.httpService = httpService;
  }
  public confirmationService = inject(ConfirmationService);

  key = 'xmlExport';

  private baseUrl = this.config.apiHost;

  downloadJedinicaGradivaXlsx(): void {
    if (
      !this.dynamicFormService.getFormValue(
        'earhiv~izvoz_gradiva~formati_izvoza'
      )
    ) {
      this.notificationService.error('Odaberite format izvoza');
      return;
    }

    this.confirmationService.confirm({
      key: this.key,
      accept: () => {
        this.processDownload();
      }
    });
  }

  private processDownload(): void {
    this.listViewProvider?.selectedItems$
      .pipe(take(1))
      .subscribe((selectedItems: any[]) => {
        if (selectedItems) {
          const jgUuids = selectedItems.map(
            (e) => e['en~jedinica_gradiva~glavni_identifikator']
          );
          const jgIds = selectedItems.map((e) => e['en~jedinica_gradiva~id']);
          const payload = {
            format: this.dynamicFormService.getFormValue(
              'earhiv~izvoz_gradiva~formati_izvoza'
            ),
            reportParams: {
              $addPodjedinice: this.addPodjedinice,
              jedinica_gradiva_uuid: jgUuids,
              jedinica_gradiva_id: jgIds
            }
          };

          this.addPodjedinice = false;

          this.previewReport(payload).subscribe();
        }
      });
  }

  protected doDownload = pipe(
    map((response: HttpResponse<any>) => {
      return this.extractResponseBlob(response);
    }),
    tap((data) => {
      this.downloadLink(data);
    })
  );

  public previewReport(body: any) {
    const url = `${this.baseUrl}export-data/jedinice-gradiva`;
    return this.httpService
      .request(HttpMethod.POST, url, body, {
        responseType: 'blob',
        observe: 'response'
      })
      .pipe(
        map((response) => {
          return this.extractResponseBlob(response);
        }),
        tap((data) => {
          this.downloadLink(data);
        })
      );
  }

  private downloadLink(data: any) {
    const element = document.createElement('a');
    element.href = URL.createObjectURL(data.file);
    element.download = data.filename;
    document.body.appendChild(element);
    element.click();
    element.remove();
  }

  private extractResponseBlob(response: any): { file: Blob; filename: string } {
    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition!.substring(
      contentDisposition!.indexOf('=') + 1
    );
    const mimeType = response.headers.get('Content-Type') || '';
    const data = {
      file: new Blob([response.body], { type: mimeType }),
      filename: filename
    };
    return data;
  }
}
